import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import JBImage from 'components/essentials/JBImage';
import { productCardImageSize } from 'commons/constants';

const ModularCollectionThumbnail = props => {
  const getImageWidthFromSize = () => {
    if (!props.imageSize) {
      const layoutSizes = {
        minimal: 265,
        thumbnail: 38,
      };

      return layoutSizes[props.layout] ?? 368;
    }
    const productCardSizes = {
      [productCardImageSize.small]: 265,
      [productCardImageSize.medium]: 368,
      [productCardImageSize.large]: 600,
      [productCardImageSize.modular]: 100, // Special case for modular sofas display card
      [productCardImageSize.thumb]: 36,
    };

    return productCardSizes[props.imageSize] ?? 368;
  };
  const {
    altText,
    hasOrientationRight = false,
    image,
    imageLoaded,
    imageSize = '',
    layout,
    listName,
    setImageLoaded = () => {},
    setLazy = false,
    isModularSofasPage = false,
  } = props;

  const src = image;

  const widthSize = getImageWidthFromSize();

  const commonImageProps = {
    className: classNames('object-contain', {
      'm-5': !isModularSofasPage,
      'opacity-100': imageLoaded,
      'flipped-right': hasOrientationRight,
      'max-w-[85%] max-h-[47.5%]': layout !== 'minimal' || !!listName,
      'max-h-full max-w-full': layout === 'minimal' && !listName,
    }),
    trim: 'color',
    width: widthSize,
    onLoad: () => {
      setImageLoaded(true, src);
    },
    trimPad: 20,
    lazy:
      (imageSize && !setLazy) || ['thumb', 'modular'].includes(imageSize)
        ? false
        : setLazy
        ? true
        : undefined,
    alt: altText,
  };

  if (!src) {
    return null;
  }

  return (
    <JBImage
      {...commonImageProps}
      src={src}
      loader={false}
      fit="clip"
      width={widthSize}
      height={widthSize}
    />
  );
};

ModularCollectionThumbnail.propTypes = {
  altText: PropTypes.string,
  displayOptionImages: PropTypes.bool,
  firstPopularImage: PropTypes.string,
  forceFallback: PropTypes.bool,
  hasOrientationRight: PropTypes.bool,
  image: PropTypes.string,
  imageLoaded: PropTypes.bool,
  imageSize: PropTypes.string,
  isModularSofasPage: PropTypes.bool,
  layout: PropTypes.string,
  listName: PropTypes.string,
  productCategory: PropTypes.string,
  productImageOptionTypeId: PropTypes.number,
  productImages: PropTypes.shape({
    transparent_config_image: PropTypes.string,
    transparent_hero_image_ts: PropTypes.string,
  }),
  setImageLoaded: PropTypes.func,
  setLazy: PropTypes.bool,
};

export default ModularCollectionThumbnail;
